import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

interface Props {
  className?: string;
}

const EmptyState = ({ className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <div>
        <svg
          width="257px"
          height="232px"
          viewBox="0 0 257 232"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <path
              d="M0,0 L138,0 L138,187 L0,187 L0,0 Z M104.88,0 L104.88,30.4740741 L138,30.4740741 L138,0 L104.88,0 Z"
              id="path-1"
            />
            <mask
              id="mask-2"
              maskContentUnits="userSpaceOnUse"
              maskUnits="objectBoundingBox"
              x="0"
              y="0"
              width="138"
              height="187"
              fill="white"
            >
              <use xlinkHref="#path-1" />
            </mask>
            <path
              d="M0,0 L138,0 L138,187 L0,187 L0,0 Z M104.88,0 L104.88,30.4740741 L138,30.4740741 L138,0 L104.88,0 Z"
              id="path-3"
            />
            <mask
              id="mask-4"
              maskContentUnits="userSpaceOnUse"
              maskUnits="objectBoundingBox"
              x="0"
              y="0"
              width="138"
              height="187"
              fill="white"
            >
              <use xlinkHref="#path-3" />
            </mask>
            <path
              d="M0,0 L138,0 L138,187 L0,187 L0,0 Z M104.88,0 L104.88,30.4740741 L138,30.4740741 L138,0 L104.88,0 Z"
              id="path-5"
            />
            <mask
              id="mask-6"
              maskContentUnits="userSpaceOnUse"
              maskUnits="objectBoundingBox"
              x="0"
              y="0"
              width="138"
              height="187"
              fill="white"
            >
              <use xlinkHref="#path-5" />
            </mask>
          </defs>
          <g id="images" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="emptystate_yourwork" transform="translate(0.000000, -1.000000)">
              <g id="cbs" transform="translate(0.000000, 1.000000)">
                <g
                  id="cb"
                  transform="translate(143.957708, 115.977500) rotate(40.000000) translate(-143.957708, -115.977500) translate(74.957708, 22.477500)"
                >
                  <use
                    id="Combined-Shape"
                    stroke="#DBDBDB"
                    mask="url(#mask-2)"
                    strokeWidth="4"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    xlinkHref="#path-1"
                  />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="40" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="55" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="9" width="41" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="24" width="41" height="10" />
                  <polygon
                    id="Path-2"
                    stroke="#DBDBDB"
                    strokeWidth="2"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    points="105 1 105 31 137 31"
                  />
                </g>
                <g
                  id="cb"
                  transform="translate(104.817674, 120.460650) rotate(20.000000) translate(-104.817674, -120.460650) translate(35.817674, 26.960650)"
                >
                  <use
                    id="Combined-Shape"
                    stroke="#DBDBDB"
                    mask="url(#mask-4)"
                    strokeWidth="4"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    xlinkHref="#path-3"
                  />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="40" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="55" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="9" width="41" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="24" width="41" height="10" />
                  <polygon
                    id="Path-2"
                    stroke="#DBDBDB"
                    strokeWidth="2"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    points="105 1 105 31 137 31"
                  />
                </g>
                <g id="cb" transform="translate(0.187840, 44.561249)">
                  <use
                    id="Combined-Shape"
                    stroke="#DBDBDB"
                    mask="url(#mask-6)"
                    strokeWidth="4"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    xlinkHref="#path-5"
                  />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="40" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="55" width="62" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="9" width="41" height="10" />
                  <rect id="Rectangle" fill="#EEEEEE" x="11" y="24" width="41" height="10" />
                  <polygon
                    id="Path-2"
                    stroke="#DBDBDB"
                    strokeWidth="2"
                    fill="#FFFFFF"
                    strokeDasharray="5"
                    points="105 1 105 31 137 31"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <Text color="textSecondary">
        <FormattedMessage id="projects_list.empty_state_message" />
      </Text>
    </Root>
  );
};

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
  }),
});

const Text = styled(Typography)({
  paddingTop: SPACING_UNIT * 3,
  paddingRight: SPACING_UNIT * 3,
  fontSize: 18,
});

export default EmptyState;
